// Keep standard controls and picker portals on TrackMe's main accent.
const accent = { main: '#6F947F', dark: '#5B876E', light: '#D5E0D8', contrastText: '#FFFFFF' };

export const brandPalette = {
    primary: { ...accent },
    secondary: { ...accent },
};
